/**
 * Role-data defaults shared by the role management surfaces. Role colors
 * themselves are user data, so rendering them via inline `style` is correct —
 * these constants only cover the two non-user cases: the colour a new role
 * starts from, and the dot shown for a role saved without one.
 */

/** Pre-filled in the create-role colour picker. */
export const DEFAULT_ROLE_COLOR = '#6366f1';

/** Neutral dot for roles whose `color` is null. */
export const ROLE_DOT_FALLBACK_COLOR = '#9ca3af';
